import { cx } from "../../lib/cx";
import Accent from "../ui/Accent";
import { ButtonLink } from "../ui/Button";

/**
 * Closing call to action: paper ground, centered eyebrow, uppercase
 * headline, a short line and one button (Book a Meeting by default).
 */
export default function CtaPanel({
  eyebrow = "No pressure. No pitch deck.",
  title = "It all starts with one meeting.",
  text = "Sixty minutes going over your headaches with people who speak contractor, not consultant. You talk, we listen, and you leave with a plain map of what's eating your time — and what it would take to fix it.",
  href,
  label,
  external,
  id,
  className = "bg-surface",
}) {
  return (
    <section id={id} className={cx("px-4 py-20 sm:px-6 md:py-24", className)}>
      <div className="on-light mx-auto max-w-[760px] text-center">
        <span className="eyebrow text-blue-deep">{eyebrow}</span>
        <h2 className="font-display mx-auto mt-3.5 mb-3 max-w-[640px] text-[32px] text-ink uppercase md:text-[46px]">
          <Accent>{title}</Accent>
        </h2>
        <p className="mx-auto mb-7 max-w-[620px] text-[17.5px] text-muted">
          {text}
        </p>
        <ButtonLink
          href={href}
          {...(external && { target: "_blank", rel: "noopener" })}
        >
          {label}
        </ButtonLink>
      </div>
    </section>
  );
}
